import { useQuery } from "@tanstack/react-query"
import { readCache } from "@/store/action"
import { 
  getMeQueryKey, 
  getProfileOptions, 
  getProfileQueryKey,
  getBrRankOptions,
  getCsRankOptions,
} from "@/client/@tanstack/react-query.gen"
import type { GetMeResponse, GetProfileResponse } from "@/client"


export const getUserInfo = () => { //Read userInfo cache
  const data = readCache(getMeQueryKey()) as GetMeResponse
  return data
}

export const useUserProfile = (enabled: boolean = true) => {
  return useQuery({
    ...getProfileOptions(),
    enabled,
  })
}

export const getUserProfile = () => {
  const data = readCache(getProfileQueryKey()) as GetProfileResponse
  return data
}

export const useBrRank = (id: number | undefined, enabled: boolean = true) => {
  return useQuery({
    ...getBrRankOptions({ path: { id: id ?? 0 } }),
    enabled: enabled && id !== undefined && id > 0,
  })
}

export const useCsRank = (id: number | undefined, enabled: boolean = true) => {
  return useQuery({
    ...getCsRankOptions({ path: { id: id ?? 0 } }),
    enabled: enabled && id !== undefined && id > 0,
  })
}

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   const userData = $api.useQuery('get', '/me', {}, {
//     enabled: true,
//     queryHash: 'UserInfo',
//   })
//   return userData
// }

// export const useUserInfo = (options?: Partial<UseQueryOptions>) => {
//   let opts = {
//     queryKey: [queryKey],
//     queryFn: async (): Promise<UserData> => {
//       const [resUser, resStore] = await Promise.all([
//         client.GET('/api/users'),
//         client.GET('/api/store')
//       ]);
      
//       return {
//         userInfo: (resUser?.data?.user || {})as User,
//         userShop: (resStore?.data?.userStore || {}) as UserStore
//       }
//     }
//   }
//   Object.assign(opts, options);

//   return useQuery(opts)
// }